import { Job } from './../models/job.model';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import * as fromJobs from '../reducers';
import * as fromRoot from '../../reducers';
import { Unit } from '../../settings-module/models/unit';
import * as jobsActions from '../actions/jobs.actions';
import { EMPTY_JOB } from '../models/job.model';
import { selectCurrentUser } from '../../core/selectors/auth';
import { Router } from '@angular/router';

@Component({
  selector: 'mj-view-post-job-page',
  template: `
    <mj-post-job-intro
      [jobs]="jobs$ | async"
      (createJob)="createJobHandler($event)"
    ></mj-post-job-intro>
  `,
})
export class ViewPostJobPageComponent implements OnInit, OnDestroy {
  jobs$: Observable<Job[]>;
  currentUnitSubscription$: Subscription;
  currenUserSubscription$: Subscription;
  currentUnit: Unit;
  currentUserId: number;
  isTemplate?: boolean = null;

  constructor(
    public store: Store<fromJobs.State>,
    public rootStore: Store<fromRoot.State>,
    public employmentStore: Store<fromRoot.State>,
    private _router: Router
  ) {
    this.jobs$ = this.store.select(fromJobs.getJobs);
    this.isTemplate =
      (this._router.getCurrentNavigation().extras &&
        this._router.getCurrentNavigation().extras &&
        this._router.getCurrentNavigation().extras.state &&
        this._router.getCurrentNavigation().extras.state.isTemplate) ||
      null;
  }

  public ngOnDestroy() {
    this.currentUnitSubscription$.unsubscribe();
    this.currenUserSubscription$.unsubscribe();
  }

  public ngOnInit() {
    this.currentUnitSubscription$ = this.employmentStore
      .select(fromRoot.getSelectedUnit)
      .subscribe((currentUnit: Unit) => {
        if (currentUnit) {
          this.currentUnit = currentUnit;
          this.store.dispatch(
            new jobsActions.LoadJobs({
              unit_id: currentUnit.id,
              is_draft: this.isTemplate,
              is_template: this.isTemplate,
            })
          );
        }
      });
    this.currenUserSubscription$ = this.rootStore
      .select(selectCurrentUser)
      .subscribe((v: any) => {
        this.currentUserId = v.currentUser.id;
      });
  }

  public createJobHandler($event: boolean) {
    this.store.dispatch(
      new jobsActions.SaveJob({
        job: {
          ...EMPTY_JOB,
          is_template: $event ? true : false,
          unit_id: this.currentUnit.id,
          address: this.currentUnit.address,
          poster_id: this.currentUserId,
        },
        listing: null,
      })
    );
  }
}
